import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiConfig } from '../aws-config';

const SharedWallboardPage: React.FC = () => {
  const { linkId } = useParams<{ linkId: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    const fetchSharedData = async () => {
      if (!linkId) return;

      try {
        const response = await fetch(`${apiConfig.baseUrl}${apiConfig.endpoints.getShareLink(linkId)}`);

        if (!response.ok) {
          // handle error as you already do
          setError('Failed to load shared dashboard');
          return;
        }

        const data = await response.json();
        if (data.queueIds && data.queueIds.length) {
          // Redirect to multi-queue route with queue IDs
          navigate(`/multi-queue/${data.queueIds.join(',')}`, { replace: true });
        } else {
          setError('No queues found for this share link');
        }
      } catch (e) {
        setError('Failed to load shared dashboard');
      } finally {
        setLoading(false);
      }
    };

    fetchSharedData();
  }, [linkId, navigate]);

  if (loading) {
    return <div>Loading shared dashboard...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return null; // or a fallback UI until redirect happens
};

export default SharedWallboardPage;